import './GoodsList.scss';
import { items } from '../../../mockData/Agritein-data';
import ItemCard from '../../../Item/ItemCard';
import React from 'react';

export default class GoodsList extends React.Component {
  constructor(props) {
    super(props);
    this.items = items;
  }

  render() {
    return (
      <div className="goods">
        {this.items.map(item => (
          <ItemCard
            key={item.id}
            isNew={item.isNew}
            title={item.title}
            InStock={item.InStock}
            priceFirst={item.priceFirst}
            priceSecond={item.priceSecond}
            priceThird={item.priceThird}
            imgUrl={item.imgUrl}
            inside={item.inside}
            logo={item.logo}
            producer={item.producer}
            link={item.link}
            table={item.table}
            id={item.id}
          />
        ))}
      </div>
    );
  }
}